module.exports = __webpack_public_path__ + "static/media/check_icon_gm.58ab3e27.svg";